import React, { useState, createContext } from 'react';
import endPoint from '../service/Service';

export const Context = createContext({
  user: null,
  oidcUser: null,
  setUser: () => { },
  createUser: () => { },
  signin: () => { },
});

export const ContextProviderUser = ({ children }) => {
  const [user, setUser] = useState(null);
  const [oidcUser, setOidcUser] = useState(null);

  const createUser = () => {
    const data = {
      cpf: user.username,
      email: user.email,
      name: user.name,
    };
    return endPoint.post('/users', data);
  };

  const signin = (authContext, authWith, successCallback, failureCallback) => {
    const token = authContext.userData.access_token || null;
    if (token) {
      endPoint.post('/auth/signin', { token, type: authWith })
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem('token', response.data.token);
            endPoint.get('/userinfo').then((_response) => {
              if (response.status === 200) {
                setUser(_response.data);
                setOidcUser(authContext);
                successCallback();
              }
            });
          }
        }, (error) => {
          failureCallback(error.response.data);
        });
    } else failureCallback();
  };

  return (
    <Context.Provider value={{
      user,
      setUser,
      createUser,
      oidcUser,
      signin,
    }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
